import { Injectable } from '@angular/core';
import { MessageBusService } from '@xdig/ng-microkernel/micro-frontend';

declare let nds: any;

@Injectable({
  providedIn: 'root',
})
export class NuDataService {
  constructor(public messageBusService: MessageBusService) {}

  obtainWidgetData() {
    let elementoInput = null;
    if (<HTMLInputElement>document.getElementById('nds-pmd') != null) {
      elementoInput = (<HTMLInputElement>document.getElementById('nds-pmd')).value;
    } else {
      elementoInput = null;
    }
    this.messageBusService.emit('shell', 'nudata.widgetValue', elementoInput);
  }

  clear() {
    nds.clear();
  }

  stop() {
    nds.stop();
  }

  setParameters(sessionId?: string, placement?: string, placementPage?: string) {
    nds.setSessionId(sessionId);
    nds.setPlacement(placement);
    nds.setPlacementPage(placementPage);
  }

  reinit() {
    nds.reinit();
  }

  bindNewFields() {
    nds.bindNewFields();
  }

  SetInitialData(sessionId?: string, placement?: string, placementPage?: string) {
    if (typeof nds != 'undefined') {
      this.setParameters(sessionId, placement, placementPage);
      this.reinit();
      this.clear();
      this.bindNewFields();
    }
  }
}
